import { useEffect, useState } from "react"
import { Heading, Loading, Section } from "../../components"
import { useAppState } from "../../hooks"
import { getHistory } from "../../api"
import { THistory } from "../../types"
import { BiRefresh } from "react-icons/bi"

import './history.scss';

export const History = () => {
    const { state } = useAppState()
    const [loading, setLoading] = useState(false)
    const [histories, setHistories] = useState<THistory[]>()

    useEffect(() => {
        refresh()
    }, [])

    const refresh = () => {
        setLoading(true)
        getHistory({ token: state?.token }).then(res => {
            if (res.histories) {
                setHistories(res.histories)
            }
        }).finally(() => setLoading(false))
    }

    function getTypeClass(type: string): string {
        let className = 'history'
        if (type.endsWith('-OK')) {
            className += '__ok'
        } else if (type.endsWith('-NOK')) {
            className += '__nok'
        }
    return className
    }

    function getTypeName(type: string): string {
        if (type.startsWith('C')) {
            return 'Stanoviště: '
        } else if (type.startsWith('B')) {
            return 'Bonus: '
        } else if (type.startsWith('H')) {
            return 'Nápověda:'
        }            
        return ''
    }

    if (loading) {
        return <Loading />
    }

    return (
        <>
            <Heading headline='Historie akcí' weight={1} />
            <div className='refresh'>
                <BiRefresh onClick={refresh} size={25} />
            </div>
            <Section>
                <div className='histories'>
                    {
                        histories
                            ? histories.map(h =>
                                <div className='history'>
                                    <div className={getTypeClass(h.type)}>
                                        <div className='history__header'>
                                            <div className='history__header__code'>
                                                {getTypeName(h.type) }<strong>{h.code}</strong>
                                            </div>
                                            <div className='history__header__time'>
                                                {new Date(h.time).toLocaleTimeString()}
                                            </div>
                                        </div>
                                        <div className='history__message'>{h.message}</div>
                                    </div>
                                </div>
                                )
                            : <></>
                    }
                </div>
            </Section>
        </>
    )
}
